import HelpCircle from "assets/icons/HelpCircle.svg"
import { useTranslation } from "react-i18next"
import { useCurrentCompanyContext } from "../../CurrentCompanyProvider"
import { BigItem } from "../components"

type LinkHelpCenterProps = { onClick: () => void }
export const LinkHelpCenter = ({ onClick }: LinkHelpCenterProps) => {
  const { t } = useTranslation()

  const {
    currentCompany: { id: companyId },
  } = useCurrentCompanyContext()

  const educationHelpUrl = "https://help.educationplayground.com/"
  const attensiHelpUrl = "https://help.attensi.com/hc/en-us"

  const companyIdsForEducationHelpUrl = [
    "868", // supercuts
    "966", // educationPlaygroundUS
    "967", // educationPlaygroundCA
  ]

  const helpLink = companyIdsForEducationHelpUrl.includes(companyId)
    ? educationHelpUrl
    : attensiHelpUrl

  const helpDescription = companyIdsForEducationHelpUrl.includes(companyId)
    ? t("settings.HELP_BUTTON_DESCRIPTION")
    : t("settings.HELP_ATTENSI_DESCRIPTION")

  return (
    <BigItem
      title={t("settings.HELP_ATTENSI")}
      icon={HelpCircle}
      description={helpDescription}
      onClick={onClick}
      href={helpLink}
    />
  )
}
